(function () {
	let resizeTimer;

	function swiperInit() {
		subSliderInit(true);
		sliderInit(true);
	}

	function destroySwiperInstance(el) {
		if (!el || !el.swiper) return;
		if (typeof el.swiper.destroy !== 'function' || el.swiper.destroyed) return;
		el.swiper.destroy(true, true);
	}

	function handleResize() {
		document.querySelectorAll('.js-media-list').forEach(function (el) {
			destroySwiperInstance(el);
		});

		document.querySelectorAll('.js-media-sublist').forEach(function (el) {
			destroySwiperInstance(el);
		});

		swiperInit();
	}

	document.addEventListener('shopify:section:load', function (e) {
		swiperInit();
	});

	window.addEventListener('resize', function () {
		window.clearTimeout(resizeTimer);
		resizeTimer = window.setTimeout(handleResize, 150);
	}, { passive: true });

	swiperInit();
})();
